<script>
  import HighCharts from 'highcharts'

  // HighCharts.setOptions()
  HighCharts.setOptions({
    lang: {
      loading: 'Aguarde...',
      months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Maio', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      exportButtonTitle: 'Exportar',
      printButtonTitle: 'Imprimir',
      rangeSelectorFrom: 'De',
      rangeSelectorTo: 'Até',
      rangeSelectorZoom: 'Periodo',
      downloadPNG: 'Download imagem PNG',
      downloadJPEG: 'Download imagem JPEG',
      downloadPDF: 'Download documento PDF',
      downloadSVG: 'Download imagem SVG'
      // resetZoom: "Reset",
      // resetZoomTitle: "Reset,
      // thousandsSep: ".",
      // decimalPoint: ','
    }
  })
  import MediaFipeTable from './media-fipe-comitentes/table'

  export default {
    name: 'relatorio-basico-media-comitentes',
    props: ['data', 'all', 'sucatas', 'salvados', 'period', 'comitente'],
    data () {
      // let _data = []
      let _mediaVenda = []
      let _mediaFipe = []
      let meses = []
      Object.keys(this.data.mediaMeses).forEach(v => {
        let data = v.split('/')
        let Meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
        let mes = Meses[parseInt(data[0]) - 1]
        meses.push(mes)
        _mediaVenda.push(Number(this.data.mediaMeses[v].percentualVenda))
        _mediaFipe.push(Number(this.data.mediaMeses[v].salvadosPercentualFipe))
        /* _data.push({
          'name': 'v.comitente',
          'y': Number(this.data.mediaMeses[v].salvadosPercentualFipe)
        }) */
      })
      return {
        options: {

          chart: {
            type: 'column'
          },
          title: null,
          xAxis: {
            categories: meses
          },
          credits: {
            enabled: false
          },
          series: [{
            name: 'Média Venda',
            data: _mediaVenda
          }, {
            name: 'Média Fipe',
            data: _mediaFipe
          }],
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y:.0f}%'
              }
            }
          },

          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}%</b><br/>'
          }

        },
        mostrarTotal: true,
        mostrarSalvados: true,
        mostrarSucatas: true,
        filtroComitente: ''
      }
    },
    computed: {
      comitentes () {
        return this.data.map((v) => {
          return v.nome
        })
      },
      filteredData () {
        let data = this.data
        if (this.filtroComitente !== '') {
          data = data.filter((v) => v.nome === this.filtroComitente)
        }
        return data
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      an (v) {
        return Math.round(Number(v))
      },
      semAno (v) {
        return String(v.slice(0, -5))
      },
      print () {
        window.print()
      },
      leiloesCData (l) {
        let leiloes = []
        let type
        l.forEach((v) => {
          leiloes.push({type: 'header', data: v.data})
          type = 'salvados'
          leiloes.push({
            type: 'Salvados',
            data: v.data,
            quantidade: v[`${type}Quantidade`],
            vendidos: v[`${type}Vendidos`],
            percentualVenda: v[`${type}PercentualVenda`],
            percentualFipe: v[`${type}PercentualFipe`]
          })
          type = 'sucatas'
          leiloes.push({
            type: 'Sucatas',
            data: v.data,
            quantidade: v[`${type}Quantidade`],
            vendidos: v[`${type}Vendidos`],
            percentualVenda: v[`${type}PercentualVenda`],
            percentualFipe: v[`${type}PercentualFipe`]
          })
          leiloes.push({
            type: 'Total',
            data: v.data,
            quantidade: v[`quantidade`],
            vendidos: v[`vendidos`],
            percentualVenda: v[`percentualVenda`],
            percentualFipe: v[`percentualFipe`]
          })
        })
        return leiloes
      }
    },
    components: {MediaFipeTable},
    filters: {
      translate (v) {
        return v === 'Salvados' ? 'Veiculos' : v
      },
      translateMes (v) {
        let data = v.split('/')
        let Meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
        let mes = Meses[parseInt(data[0]) - 1]
        return `${mes}/${data[1]}`
      }
    }
  }
</script>

<template>
  <div class="result bg-white a4">
    <div class="result-title hidden-print__no">
      <h1 class="text-uppercase">{{comitente.nome}} - RELATÓRIO MÉDIA DE RECUPERAÇÃO X FIPE</h1>
      <h3>{{period}}</h3>
      <div class="text-center hidden-print">
        <a @click="print"><i class="fa fa-print"></i> imprimir <span class="font-thin">(CTRL + P)</span></a>
      </div>
    </div>
    <div class="c-result printer-page">
      <h3 class="comitente-nome text-uppercase">{{comitente.nome}}</h3>

      <div v-for="(leilao, mes) in data.mediaMeses">
        <h4 style="background-color: #f2f2f2 !important;-webkit-print-color-adjust: exact;">{{mes|translateMes}}</h4>
        <table class="tbl-result">
          <tr>
            <th style="color: #000">Média Fipe</th>
            <th style="color: #000">{{an(leilao.salvadosPercentualFipe)}}%</th>
          </tr>
          <tr>
            <th style="color: #000">Média Venda</th>
            <th style="color: #000">{{an(leilao.percentualVenda)}}%</th>
          </tr>
        </table>
      </div>

      <div class="chart m-t">
        <highcharts :options="options"></highcharts>
      </div>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// ResultMediaFipeComitenteMes.vue?28515118